import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../styles/CanCodeQuery.css";
import cowBackground from "../images/cow-background.jpg";
import logo from "../images/NZ-Pure-Dairy-Logo.svg";
import { formatDateForDisplay } from "../utils/dateUtils";
import API_BASE_URL from "../config";

const CanCodeQuery = () => {
  const { code: canCode } = useParams(); // 从 /c/:code 获取罐底码
  const [batchInfo, setBatchInfo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (canCode) {
      fetch(`${API_BASE_URL}/api/scan/${canCode}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            setError(data.error);
          } else {
            setBatchInfo({
              product_name: data.product_name,
              batch_no: data.batch_number,
              manufacture_date: data.manufacture_date,
              expiry_date: data.expiry_date,
              distributors: data.distributors || [],
              manufacturer: "New Zealand Pure Dairy Products Limited.",
              origin: "New Zealand",
            });
          }
        })
        .catch((err) => {
          console.error("Failed to fetch batch info:", err);
          setError("Failed to fetch batch info.");
        });
    } else {
      setError("No code found in URL.");
    }
  }, [canCode]);

  return (
    <div
      className="batch-container"
      style={{ backgroundImage: `url(${cowBackground})` }}
    >
      <div className="batch-card">
        <div className="logo-container">
          <img src={logo} alt="NZ Pure Dairy Logo" className="logo" />
        </div>

        <h1>Product Information</h1>
        {canCode && (
          <p className="code-label">
            <strong>Can Serial Number: </strong>
            {canCode}
          </p>
        )}

        {error && <p className="error-message">{error}</p>}
        {batchInfo ? (
          <div className="batch-details">
            <p>
              <strong>Batch Number:</strong> {batchInfo.batch_no}
            </p>
              <p>
              <strong>Product Name:</strong> {batchInfo.product_name}
            </p>
            <p>
              <strong>Manufacturer:</strong> {batchInfo.manufacturer}
            </p>
            <p>
              <strong>Address:</strong> Unit 3, 14 Canaveral Drive, Rosedale,
              Auckland, New Zealand
            </p>
            <p>
              <strong>Product Origin:</strong> {batchInfo.origin}
            </p>
            <p>
              <strong>Manufacture Date:</strong>{" "}
              {formatDateForDisplay(batchInfo.manufacture_date)}
            </p>
            <p>
              <strong>Expiry Date:</strong>{" "}
              {formatDateForDisplay(batchInfo.expiry_date)}
            </p>

            {batchInfo.distributors.length > 0 && (
              <>
                <p>
                  <strong>Distributor:</strong>
                </p>
                <div className="distributor-list">
                  {batchInfo.distributors.map((d, index) => (
                    <div key={index} className="distributor-block">
                      <p>{d.name}</p>
                      <ul className="website-list">
                        {d.websites.map((w, i) => (
                          <li key={i} className="distributor-website-item">
                            🌐{" "}
                            <a
                              href={w.website}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="distributor-link"
                            >
                              Visit distributor website
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        ) : (
          !error && <p className="loading-message">Loading...</p>
        )}

        <div className="marketing-button-container">
          <a
            href="https://www.nzpuredairy.co.nz"
            target="_blank"
            rel="noopener noreferrer"
            className="marketing-button"
          >
            Visit Our Website
          </a>
        </div>
      </div>
    </div>
  );
};

export default CanCodeQuery;
